import React, { useContext, useEffect, } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CartContext } from "../contexts/CartContext.js";
import { stripeGetSuccessCheckoutAPI } from '../apis/apiStripe.js';

const CheckoutReturnPage = () => {
  const navigate = useNavigate();
  const { clearCart } = useContext(CartContext);
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Nous définissons une fonction asynchrone à l'intérieur du useEffect
    console.log('sessionId', sessionId);
    const fetchSuccessCheckout = async () => {
      try {
        const productsResponse = await stripeGetSuccessCheckoutAPI(sessionId);
        // Ici, vous pouvez utiliser productsResponse pour remplir votre dataLayer
        // ou gérer vos données de commande dynamiquement.

        window.dataLayer = window.dataLayer || [];

        // Construisez un tableau d'items conformes
        const items = productsResponse.products.map((p) => ({
          item_name: p.product,        
          price: p.price,               
          quantity: p.quantity,         
        }));

        window.dataLayer.push({
          event: 'purchase',
          ecommerce: {
            transaction_id: productsResponse.session.payment_intent,
            affiliation: 'Boutique en ligne',
            value: productsResponse.session.amount_total / 100,
            currency: 'EUR',
            tax: productsResponse.session.total_details.amount_tax / 100,
            shipping: productsResponse.session.total_details.amount_shipping / 100,
            coupon: productsResponse.discounts[0]?.coupon,
            items: items, 
          },
        });
      } catch (error) {
        console.error('Erreur lors de la récupération du checkout succès :', error);
      }

      // Nettoyage du panier
      clearCart();
      localStorage.removeItem('cart');

      // Force la page à se recharger si le panier existe encore pour une raison quelconque
      const localCart = JSON.parse(localStorage.getItem('cart'));
      if (localCart && localCart.length > 0) {
        navigate(0);
      }
    };

    // Appel de la fonction asynchrone
    fetchSuccessCheckout();
  }, []);

  return (
    <div
      style={{
        fontFamily: 'sans-serif',
        maxWidth: '800px',
        margin: '0 auto',
        padding: '2rem',
        textAlign: 'center',
      }}
    >
      <h1>Merci pour votre achat</h1>
      <p>Votre commande a été confirmée.</p>
    </div>
  );
};

export default CheckoutReturnPage;
